$(document).ready(() => {
    $('.year-selectbox .year').on('change', function() {
        let url = this.form.action;
        if (this.value != '---') {
            url = url + '/' + this.value;
        }
        location = url;
    });
});
